const sectionPostCss = `
[data-type='section-post'] .post-wrapper {
  padding-block: 40px;
}

[data-type='section-post'] .post-breadcrumb {
  margin: 0 0 16px 0 !important;
  font-size: 18px;
  opacity: 0.8;
}

[data-type='section-post'] .post-title h1,
[data-type='section-post'] .post-title h2,
[data-type='section-post'] .post-title h3 {
  font-size: 32px;
  line-height: normal;
  margin: 0 0 12px 0 !important;
}

[data-type='section-post'] .post-title p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-post'] .post-author-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 24px 0;
}

[data-type='section-post'] .post-author-info .post-author-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
}

[data-type='section-post'] .post-author-info .post-author-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-post'] .post-author-divider {
  width: 1px;
  height: 60px;
  background-color: #e5e7eb;
}

[data-type='section-post'] .post-author-info-content .post-author-name {
  margin: 0 0 4px 0 !important;
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
}

[data-type='section-post'] .post-author-info-content .post-author-time {
  font-size: 14px;
  opacity: 0.8;
  margin: 0 !important;
}

[data-type='section-post'] .post-summary {
  padding: 16px;
  margin-bottom: 16px;
  background-color: #eafdd7;
}

[data-type='section-post'] .post-summary h1,
[data-type='section-post'] .post-summary h2,
[data-type='section-post'] .post-summary h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 12px 0 !important;
}

[data-type='section-post'] .post-summary h1:last-child,
[data-type='section-post'] .post-summary h2:last-child,
[data-type='section-post'] .post-summary h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-post'] .post-summary p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-post'] .post-summary p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-post'] .post-content h1,
[data-type='section-post'] .post-content h2,
[data-type='section-post'] .post-content h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 12px 0 !important;
}

[data-type='section-post'] .post-content p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-post'] .post-content figure {
  margin: 0 auto;
}

[data-type='section-post'] .post-content figure img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@container (max-width: 768px) {
  [data-type='section-post'] .post-wrapper {
    padding-block: 16px;
  }

  [data-type='section-post'] .post-breadcrumb {
    font-size: 13px;
  }

  [data-type='section-post'] .post-title h1,
  [data-type='section-post'] .post-title h2,
  [data-type='section-post'] .post-title h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-post'] .post-title p {
    font-size: 14px;
  }

  [data-type='section-post'] .post-author-info {
    margin: 16px 0;
  }

  [data-type='section-post'] .post-author-info .post-author-avatar {
    width: 50px;
    height: 50px;
  }

  [data-type='section-post'] .post-author-divider {
    height: 40px;
  }

  [data-type='section-post'] .post-summary {
    padding: 8px;
    margin-bottom: 8px;
  }

  [data-type='section-post'] .post-summary h1,
  [data-type='section-post'] .post-summary h2,
  [data-type='section-post'] .post-summary h3,
  [data-type='section-post'] .post-content h1,
  [data-type='section-post'] .post-content h2,
  [data-type='section-post'] .post-content h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-post'] .post-summary p,
  [data-type='section-post'] .post-content p {
    font-size: 14px;
  }

  [data-type='section-post'] .post-content figure {
    width: 98% !important;
  }
}
`;
export default sectionPostCss;
